module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_9005.7196d983.png";